import { Button, Dialog, DialogActions, DialogContent, Grid, Typography } from '@mui/material';
import { X } from '../../../../assets';
import { useTranslation } from 'react-i18next';

export interface Reasons {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  name: string | undefined;
  title: string;
  message: string;
  confirmLabel: string;
  confirmVariant?: 'secondary' | 'bad';
}

const RemoveItemConfirm = (props: Reasons) => {
  const { t } = useTranslation('quickOrder');

  return (
    <Dialog open={props.open}
      onClose={props.onClose}
      maxWidth='md'
      fullWidth>
      <Grid
        sx={{ m:'2px' }}>
        <Grid
          sx={{ display:'flex',alignItems:'flex-end', justifyContent:'flex-end' }}>
          <X  onClick={props.onClose} />
        </Grid>
        <Grid
          sx={{ display:'flex',alignItems:'center', justifyContent:'center' }}>
          <Typography variant='textXL'> {props.title}</Typography>
        </Grid>
      </Grid>
      <DialogContent>
        <Grid sx={{ pt:'10px', display:'flex', justifyContent:'center',alignContent:'center' }}>
          <Typography variant='textMD'> {props.message}</Typography>
        </Grid>
        <Grid sx={{ pt:'10px', display:'flex', justifyContent:'center',alignContent:'center' }}>
          <Typography variant='textMD'
            sx={{ fontWeight:'bold' }}> {props.name}</Typography>
        </Grid>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          onClick={props.onClose}> {t('cancel')}</Button>
        <Button onClick={props.onConfirm}
          variant={props.confirmVariant ?? 'bad'}
        >
          {props.confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveItemConfirm;